/**
 * Error handler for form validation.
 *
 * @author Matej Svajger <hello@matejsvajger.com>
 */
export default class Errors {
  /**
   * Create a new Errors instance.
   */
  constructor () {
    this.errors = {}
    this.callbacks = {
      onRecord: [],
      onClear: []
    }
  }

  /**
   * Determine if an errors exists for the given field.
   *
   * @param {string} field
   */
  has (field) {
    if (typeof field === 'string') {
      return Object.prototype.hasOwnProperty.call(this.errors, field)
    } else {
      var has = false
      field.forEach(item => {
        if (this.has(item)) {
          has = true
        }
      })
      return has
    }
  }

  /**
   * Determine if we have any errors.
   */
  any () {
    return Object.keys(this.errors).length > 0
  }

  /**
   * Retrieve the error message for a field.
   *
   * @param {string} field
   */
  get (field) {
    if (this.errors[field || 'default']) {
      return (typeof this.errors[field] === 'string')
        ? this.errors[field]
        : this.errors[field][0]
    }
  }

  /**
   * Record the new errors.
   *
   * @param {object} errors
   */
  record (error, value) {
    if (typeof error === 'string') {
      this.errors[error] = value
    } else {
      this.errors = error
    }

    this.callbacks.onRecord.forEach(
      fn => fn(this, typeof error === 'string' ? error : undefined, value)
    )
  }

  /**
   * Clear one or all error fields.
   *
   * @param {string|null} field
   */
  clear (field) {
    if (field) {
      delete this.errors[field]
      return
    }

    this.errors = {}

    this.callbacks.onClear.forEach(
      fn => fn(this, field)
    )
  }

  onRecord (callback) {
    this.callbacks.onRecord.push(
      callback
    )
  }

  onClear (callback) {
    this.callbacks.onClear.push(
      callback
    )
  }
}
